import { Calendar, ChevronRight, MapPin } from 'tabler-icons-react';
import moment from 'moment-jalaali';
moment.loadPersian({ dialect: 'persian-modern' });
import styles from 'partials/story-header.module.scss';

/* eslint-disable */
export const SidebarStoryHeader = ({ header, onBack, hasMeta = true }) => {
	return (
		<header className={styles.header}>
			<h2
				className={styles.title}
				onClick={onBack}>
				<ChevronRight size={20} className={styles.backIcon} />
				{header.title}
			</h2>
			{hasMeta && (
				<div className={styles.meta}>
					<div className={styles.metaItem}>
						<Calendar size={20} className={styles.metaIcon} />
						{moment
							.unix(header.start_date)
							.format('jD jMMMM jYYYY')}
					</div>
					<div className={styles.metaItem}>
						<MapPin size={20} className={styles.metaIcon} />
						{`${header.location.title} - ${header.location.city.name}`}
					</div>
				</div>
			)}
		</header>
	);
};
